import {Component} from '@angular/core';
import {SupportDeskKanbanComponent} from './kanban-board/support-desk-kanban.component';

@Component({
  selector: 'app-cross-game-support-desk',
  standalone: true,
  imports: [SupportDeskKanbanComponent],
  template: '<app-support-desk-kanban [isCrossGameView]="true"></app-support-desk-kanban>'
})
export class CrossGameSupportDeskComponent {}
